export default __webpack_public_path__ + "static/media/negocios-digitais.823fce28.png";